import {
    Icon20Attach,
    Icon20Chain,
    Icon20ChecksOutline,
    Icon20DeleteClockAltOutline,
    Icon20DocumentOutline,
    Icon20DumpbellOutline,
    Icon20HistoryBackwardOutline,
    Icon20MailOutline,
    Icon20MailStackOutline,
    Icon20ReplyOutline,
    Icon20SmartphoneOutline,
    Icon20TrashSimpleOutline,
} from '@vkontakte/icons';
import { ReactComponent as CloudLogo } from 'img/quota-landing/cloud-logo-new.svg';
import { ReactComponent as MailLogo } from 'img/quota-landing/mail-logo-new.svg';
import React from 'react';
import { UserQuotaGroupId } from 'reactApp/types/QuotaCleaner';
import { Icon20ThumbsDownOutline, VideoIcon } from 'reactApp/ui/VKUIIcons';

export const FastCleanerGroupTitles = {
    [UserQuotaGroupId.Backup]: 'Резервные копии',
    [UserQuotaGroupId.CameraUploads]: 'Автозагрузка с телефона',
    [UserQuotaGroupId.CloudLarge]: 'Тяжёлые файлы',
    [UserQuotaGroupId.CloudOld]: 'Старые файлы',
    [UserQuotaGroupId.LargeInbox]: 'Тяжёлые входящие',
    [UserQuotaGroupId.LargeSent]: 'Тяжёлые отправленные',
    [UserQuotaGroupId.Mounted]: 'С вами поделились',
    [UserQuotaGroupId.Newsletters]: 'Рассылки',
    [UserQuotaGroupId.OldInbox]: 'Старые входящие',
    [UserQuotaGroupId.OldSent]: 'Старые отправленные',
    [UserQuotaGroupId.Read]: 'Прочитанные',
    [UserQuotaGroupId.MailBin]: 'Корзина',
    [UserQuotaGroupId.MailSpam]: 'Спам',
    [UserQuotaGroupId.Video]: 'Видео',
    [UserQuotaGroupId.WithAttaches]: 'С вложениями',
    [UserQuotaGroupId.CloudBin]: 'Корзина',
    ['cloud']: 'Облако',
    ['mail']: 'Почта',
};

export const FastCleanerIcon = ({ groupId }: { groupId: UserQuotaGroupId | 'cloud' | 'mail' }) => {
    // eslint-disable-next-line sonarjs/max-switch-cases
    switch (true) {
        case groupId === UserQuotaGroupId.Backup:
            return <Icon20HistoryBackwardOutline />;
        case groupId === UserQuotaGroupId.CameraUploads:
            return <Icon20SmartphoneOutline />;
        case groupId === UserQuotaGroupId.CloudLarge:
            return <Icon20DumpbellOutline />;
        case groupId === UserQuotaGroupId.CloudOld:
            return <Icon20DeleteClockAltOutline />;
        case groupId === UserQuotaGroupId.LargeInbox:
            return <Icon20MailOutline />;
        case groupId === UserQuotaGroupId.LargeSent:
            return <Icon20ReplyOutline />;
        case groupId === UserQuotaGroupId.Mounted:
            return <Icon20Chain />;
        case groupId === UserQuotaGroupId.Newsletters:
            return <Icon20MailStackOutline />;
        case groupId === UserQuotaGroupId.OldInbox:
            return <Icon20MailOutline />;
        case groupId === UserQuotaGroupId.OldSent:
            return <Icon20ReplyOutline />;
        case groupId === UserQuotaGroupId.Read:
            return <Icon20ChecksOutline />;
        case groupId === UserQuotaGroupId.MailBin:
            return <Icon20TrashSimpleOutline />;
        case groupId === UserQuotaGroupId.MailSpam:
            return <Icon20ThumbsDownOutline />;
        case groupId === UserQuotaGroupId.Video:
            return <VideoIcon />;
        case groupId === UserQuotaGroupId.WithAttaches:
            return <Icon20Attach />;
        case groupId === UserQuotaGroupId.CloudBin:
            return <Icon20TrashSimpleOutline />;
        // Оптимизируем код - это для блоков-заголовков
        case groupId === 'cloud':
            return <CloudLogo height={20} width={20} />;
        case groupId === 'mail':
            return <MailLogo height={20} width={20} />;

        // решим проблемы будущих нас
        default:
            return <Icon20DocumentOutline />;
    }
};
